import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
// import { environment } from '../../../../environments/environment';

import { API } from 'aws-amplify';
import { Observable } from 'rxjs';
import { ConfigService } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class SignalHttpService {

    apiName: string;

    constructor(private http: HttpClient, private configService: ConfigService) {
        this.apiName = this.configService.get('host');
    }

	getSignalStrength(m_id) {
		return new Observable((observer: any) => {
			const path = '/dashboard/get-signal-strength/' + m_id;
			const myInit = {
				response: false
			};
			API.get(this.apiName, path, myInit).then(response => {
			  observer.next(response);
			}).catch(err => {
				console.log(err.response);
				observer.error(err);
			});
		});
	}
}
